<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import SeedEmpty from '$icons/SeedEmptyIcon.svelte';
  import type { FPost, WithCreatorData } from 'garden-common';
  import PostHeart from '$icons/PostHeartIcon.svelte';
  import PostFolder from '$icons/PostFolderIcon.svelte';
  import PostComment from '$icons/PostCommentIcon.svelte';
  import type { FPost, WithCreatorData } from 'garden-common';
  import { me } from '$stores/user.store';
  import { isMobile } from '$src/stores/media.store';

  // Should be in a ts file
  // export type PostButtonRowEvent = 'donate' | 'appreciate' | 'comment' | 'save';

  export let post: Partial<FPost<string>> & Partial<WithCreatorData>;

  const dispatch = createEventDispatcher<{
    donate: unknown;
    appreciate: unknown;
    comment: unknown;
    save: unknown;
  }>();
</script>

<div class="flex gap-x-4 text-blueish-grey-700 justify-around text-sm">
  <button on:click={() => dispatch('donate')} class="break-keep whitespace-nowrap font-switzer">
    <SeedEmpty />
    Donate seed
  </button>

  <button class="font-switzer" on:click={() => dispatch('appreciate')}>
    <PostHeart class={post?.likes?.includes($me?._id) ? 'stroke-color-red-base' : null} />
    Appreciate
  </button>

  <button class="font-switzer" on:click={() => dispatch('comment')}>
    <PostComment class={post?.comments?.includes($me?._id) ? 'stroke-[#1DA1F2]' : null} />
    Comment
  </button>

  {#if !$isMobile}
    <button class="font-switzer" on:click={() => dispatch('save')}>
      <PostFolder color={post?.savers?.includes($me?._id) ? 'stroke-brand-green' : null} />
      Save
    </button>
  {/if}
</div>

<style lang="postcss">
  div > button {
    @apply flex gap-x-2 items-center;
  }
</style>
